/**
 * 404 — rendered by TanStack Router when no route matches. The
 * legacy web/ ships a full HTML shell to keep the 404 styled, but a
 * TanStack-Router 404 already inherits the root layout, so we only
 * need the page body here.
 */
export function NotFound() {
  return (
    <main className="grid min-h-dvh place-items-center p-8 text-center">
      <div>
        <h1 className="text-3xl font-semibold">404</h1>
        <p className="mt-2 text-sm text-muted-foreground">Diese Seite gibt es nicht.</p>
      </div>
    </main>
  );
}
